export const DELAYED_NITRO_POOLS = [
  '0x4cd727e194307924fc280af59fc4ba6e7f3cbd90',
  '0x6ec4a4c83463ff4fa5b16f8d062078a183e29677',
  '0x71ce231441ea820c914e55d66c8954c0859c82ea',
  '0x7de96cc11dad9bc67efd8f632907bbbda10005fc',
  '0xe95630bd8f42f97b237a0ec793a1c073ca7c2337'
];

export const DELAYED_NITRO_CLAIM_URL = '';
